(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["molivrae-home-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('molivrae-slideshow')) {
  customElements.define('molivrae-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController(); const options = {signal:this.abort.signal};
      this.slides = [...this.querySelectorAll('[data-slide]')]; this.dots = [...this.querySelectorAll('[data-go]')]; this.current = 0; this.sequence = 0; this.firstReady = false;
      if (this.slides.length < 2) return;
      this.toggle = this.querySelector('[data-toggle]'); this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches; this.visible = true;
      this.querySelector('.mv-home-hero__controls').hidden = false;
      
      
      this.dots.forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.go)),options));
      this.toggle.addEventListener('click',()=>{this.playing=!this.playing;this.schedule()},options);
      
      
      this.addEventListener('focusin',e=>{if(e.target.closest('[data-toggle]') || !e.target.matches(':focus-visible'))return;this.playing=false;this.schedule()},options);
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.current+(e.key==='ArrowRight'?1:-1))}},options);
      this.addEventListener('touchstart',e=>{this.touch={x:e.touches[0].clientX,y:e.touches[0].clientY}}, {...options,passive:true});
      this.addEventListener('touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)){this.playing=false;this.show(this.current+(dx<0?1:-1))}this.touch=null},options);
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.playing=false;this.schedule()},options);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:.15});this.observer.observe(this);
      this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.playing=false;this.show(i)}},options);
      this.prepareSlide(0, 'high').then(loaded => {if(loaded && this.isConnected){this.firstReady=true;this.schedule()}});
    }
    async prepareSlide(index, priority = 'low') {
      const slide = this.slides[index];
      const template = slide.querySelector('template[data-slide-media]');
      if (template) {slide.prepend(template.content.cloneNode(true));template.remove()}
      const image = slide.querySelector('img');
      if (!image) return true;
      image.fetchPriority = priority; image.loading = 'eager';
      if (image.complete && image.naturalWidth) return true;
      try {await image.decode();return true} catch {return false}
    }
    async show(index) {
      const next = (index + this.slides.length) % this.slides.length;
      const sequence = ++this.sequence;
      clearTimeout(this.timer);
      const loaded = await this.prepareSlide(next, 'high');
      if (!loaded) {this.playing=false;this.schedule();return}
      if (!this.isConnected || sequence !== this.sequence) return;
      this.current = next;
      this.slides.forEach((slide, i) => {const active=i===next;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active});
      this.dots.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===next)));
      this.schedule();
    }
    schedule(){
      clearTimeout(this.timer);
      if(!this.toggle)return;
      this.toggle.setAttribute('aria-label',this.playing?this.toggle.dataset.pause:this.toggle.dataset.play);
      this.toggle.querySelector('[data-pause-icon]').hidden=!this.playing;
      this.toggle.querySelector('[data-play-icon]').hidden=this.playing;
      if(this.playing&&this.visible&&!document.hidden&&this.firstReady){
        const next=(this.current+1)%this.slides.length;
        this.prepareSlide(next);
        this.timer=setTimeout(()=>this.show(next),Number(this.dataset.interval)||5000);
      }
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();
})();
